import editMemberAddressTemplate from './edit_member_address.template.html';

class WbEditMemberAddressController {

    constructor(LoadingService, $scope, AlertService, WbAddressLookupService) {
        'ngInject';

        const injectables = {
            LoadingService,
            $scope,
            AlertService,
            WbAddressLookupService
        };

        Object.assign(this, injectables);
    }

    $onInit() {
        // Initialise the loading spinner
        console.log(this.member);
        this.loader = this.LoadingService.$loader(this.$scope);
        this.resetValues();
    }

    resetValues() {
        this.memberValues = {
            address1: this.member.address1,
            address2: this.member.address2,
            address3: this.member.address3,
            address4: this.member.address4,
            postcode: this.member.postcode
        };
        delete this.postcodeSearchValue;
        delete this.error;
        delete this.addresses;
    }

    toggleEdit() {
        this.editMode = !this.editMode;
        if (this.editMode) { 
            delete this.status;
        } else {
            // Reset the values when leaving edit mode
            this.resetValues();
        }
    }

    lookupPostcode() {
        this.loader.notLoaded();
        const self = this;
        this.WbAddressLookupService.lookupPostcode(this.postcodeSearchValue).then(results => {
            self.response = "";
            self.addresses = results;
            for (var index = 0; index < self.addresses.length; index++) {
                var arrElement;
                var element = self.addresses[index];

                let addressParts = [];

                if (element.property) {
                    addressParts.push(element.property);
                }
                if (element.subbuilding) {
                    addressParts.push(element.subbuilding);
                }
                addressParts.push(element.street);
                addressParts.push(element.town);
                addressParts.push(element.area);
                addressParts.push(element.postcode);

                element.displayText = addressParts.join(', ');
            }
            this.loader.setLoaded();
        }, err => {
            self.error = err;
            this.loader.setLoaded();
        });
    }

    selectAddress() {
        console.log(this.selectedAddress);

        if (this.selectedAddress) {
            if (this.selectedAddress.property) {
                this.memberValues.address1 = this.selectedAddress.property;
                this.memberValues.address2 = this.selectedAddress.street;
            } else {
                this.memberValues.address1 = this.selectedAddress.street;
                this.memberValues.address2 = "";
            }
            this.memberValues.address3 = this.selectedAddress.town;
            this.memberValues.address4 = this.selectedAddress.area;
            this.memberValues.postcode = this.selectedAddress.postcode;
        }
    }

    hasChanges() {
        return this.member.address1 != this.memberValues.address1 ||
                this.member.address2 != this.memberValues.address2 ||
                this.member.address3 != this.memberValues.address3 ||
                this.member.address4 != this.memberValues.address4 ||
                this.member.postcode != this.memberValues.postcode;
    }

    applyChanges() {
        this.member.address1 = this.memberValues.address1;
        this.member.address2 = this.memberValues.address2;
        this.member.address3 = this.memberValues.address3;
        this.member.address4 = this.memberValues.address4;
        this.member.postcode = this.memberValues.postcode;
    }

    saveChanges() {
        // save to BB
        if (this.hasChanges()) {
            this.loader.notLoaded();
            // Copy the new values to the member object
            this.applyChanges();

            // Hijack the post data to add the question answer
            let data = this.member.getPostData();
            const uprnQuestion = _.findKey(this.member.q, question => question.name == 'UPRN');
            if (uprnQuestion) {
                data.q = {};
                data.q[uprnQuestion] = {
                    answer: this.selectedAddress.uprn
                }
            }
            
            // Save the changes
            this.member.$put('self', {}, data).then(response => {
                console.log("Successfully saved member");
                this.loader.setLoaded();
                this.status = "saved";
                // Stop edit mode
                this.toggleEdit();
                this.AlertService.success({ msg: 'Successfully saved member address' });
            }, err => {
                // Show an error
                console.err("Failed to save member", err);
                this.error = err;
                this.status = "error";
                this.AlertService.success({ msg: 'Failed to save member address' });
            });
        } else {
            this.toggleEdit();
        }
    }
}

const WbEditMemberAddressComponent = {
    templateUrl: editMemberAddressTemplate.id,
    controller: WbEditMemberAddressController,
    controllerAs: '$wbEditMemberAddressCtrl',
    bindings: {
        member: '<'
    }
};

angular
    .module('westBerkshireEvents.editMember')
    .component('wbEditMemberAddress', WbEditMemberAddressComponent);

export default WbEditMemberAddressController;


// WEBPACK FOOTER //
// ../src/public/javascripts/edit-member-details/edit_member_address.component.js